import { UserDetails } from '51trips-frontend-core'
import { atom } from 'jotai'
import { atomWithQuery, queryClientAtom } from 'jotai-tanstack-query'

import { auth } from '../firebase'
import { UserRepository } from '../repositories/UserRepository'
import { queryClient } from './queryClient'

export const AUTH_QUERY_KEY = ['session', 'currentUser'] as const
export const WHO_I_AM_QUERY_KEY = ['session', 'whoIAm'] as const

export interface UserSession {
  id: string
}

const userRepository = new UserRepository()

export const fetchUserSession = (): Promise<UserSession | null> =>
  new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      unsubscribe()
      resolve(firebaseUser ? { id: firebaseUser.uid } : null)
    })
  })

export const fetchWhoIAm = (): Promise<UserDetails | null> =>
  new Promise((resolve, reject) => {
    userRepository.whoIAm().subscribe({
      next: resolve,
      error: reject
    })
  })

export const currentUserQueryAtom = atomWithQuery(() => ({
  queryKey: AUTH_QUERY_KEY,
  queryFn: fetchUserSession,
  gcTime: 10 * 60 * 1000
}))

export const whoIAmQueryAtom = atomWithQuery((get) => {
  const session = get(currentUserQueryAtom)
  const isAuthenticated = session.data != null

  return {
    queryKey: WHO_I_AM_QUERY_KEY,
    queryFn: fetchWhoIAm,
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  }
})

export const currentUserIdAtom = atom<string | null>((get) => {
  return get(currentUserQueryAtom).data?.id ?? null
})

export const currentUserAtom = atom<UserDetails | null>((get) => {
  return get(whoIAmQueryAtom).data ?? null
})

export const clearAuthCache = (): void => {
  queryClient.clear()
}

export { queryClientAtom }

export type { UserDetails }
